<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">Table of Contents</h2>
<p class="toc"><a href="#/xhtml/fm03"><em class="italic">Foreword</em></a></p>
<p class="toc1"><a href="#/xhtml/chap01"><span class="tno">Chapter 1</span> The Problem</a></p>
<p class="toc"><a href="#/xhtml/chap02"><span class="tno">Chapter 2</span> My Story</a></p>
<p class="toc"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">Chapter 3</span> The Process (CLEAR Healing Method)</span></p>
<p class="toc"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">Chapter 4</span> The Promise</span></p>
<p class="toc"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">Chapter 5</span> STEP 1—Clear &amp; Cleanse</span></p>
<p class="toc"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">Chapter 6</span> STEP 2—Listen and Feel</span></p>
<p class="toc"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">Chapter 7</span> STEP 3—Establish Action or Inaction</span></p>
<p class="toc"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">Chapter 8</span> STEP 4—Act to Inspire &amp; Motivate</span></p>
<p class="toc"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">Chapter 9</span> STEP 5—Receiving (Achieve, Accomplish &amp; The Art of Receiving)</span></p>
<p class="toc"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">Chapter 10</span> Obstacles—Past Attachments</span></p>
<p class="toc"><span href="#/xhtml/chap11" title="Link target outside of Sample"><span class="tno">Chapter 11</span> Obstacles—Beliefs</span></p>
<p class="toc"><span href="#/xhtml/chap12" title="Link target outside of Sample"><span class="tno">Chapter 12</span> Conclusion</span></p>
<p class="toc1"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em class="italic">Acknowledgments</em></span></p>
<p class="toc"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em class="italic">Thank You!</em></span></p>
<p class="toc"><span href="#/xhtml/bm03" title="Link target outside of Sample"><em class="italic">About the Author</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0c807392